// Frontend mirror of supabase/functions/_shared/settings.ts. Keep in sync.

export interface SettingsV1 {
  version: 1;
  show_sunrise: boolean;
  show_sunset: boolean;
  use_emoji: boolean;
  event_duration_minutes: 0 | 1 | 15 | 30 | 60;
  custom_event_names: Record<string, string>;
}

export type Settings = SettingsV1;

export function defaultSettings(): Settings {
  return {
    version: 1,
    show_sunrise: true,
    show_sunset: true,
    use_emoji: true,
    event_duration_minutes: 1,
    custom_event_names: {},
  };
}
